/* Apartés — ce qui rend le site personnel, en un seul fichier :
   - « Mes tailles » en trois listes (vêtements, pantalons, chaussures), lues
     sur la fiche du membre (window.APARTES_TAILLES) ou, pour une visiteuse,
     dans ce navigateur ; enregistrées en un geste ;
   - sur une Vente : la barre « Votre taille », le filtre et la pastille ;
   - sur une pièce : sa taille présélectionnée, et « Retenir ma taille » ;
   - « Ajouter à mon agenda » sur une Vente à venir (iPhone et Mac : le
     calendrier de l'appareil ; ailleurs : Google Agenda) ;
   - l'accueil : « Bonjour » ou « Bonsoir », à l'heure de la personne. */
(function () {
  'use strict';
  // Aperçu client (équipe) : tailles gardées à part, dans ce navigateur, rien n'est envoyé.
  var APERCU = window.APARTES_APERCU || null;
  var CLE = APERCU ? 'apartes-tailles:apercu:' + APERCU.cercle : 'apartes-tailles';
  var CLE_FILTRE = 'apartes-filtre-taille';
  var CLE_AGENDA = 'apartes-agenda';
  var GROUPES = ['vetements', 'pantalons', 'chaussures'];
  var membre = !!window.APARTES_MEMBRE;

  // ——— Mes tailles ———
  function vide() { return { vetements: [], pantalons: [], chaussures: [] }; }
  function normaliser(x) {
    var o = vide();
    if (Array.isArray(x)) { // ancien format : une seule liste
      x.forEach(function (t) { (/^\d/.test(t) ? o.pantalons : o.vetements).push(String(t).toUpperCase()); });
      return o;
    }
    if (x && typeof x === 'object') GROUPES.forEach(function (g) { if (Array.isArray(x[g])) o[g] = x[g].map(function (t) { return String(t).toUpperCase(); }); });
    return o;
  }
  function compte(o) { return o.vetements.length + o.pantalons.length + o.chaussures.length; }
  function lire() {
    if (APERCU) { try { var l = JSON.parse(localStorage.getItem(CLE) || 'null'); if (l) return normaliser(l); } catch (e) {} }
    var serveur = normaliser(window.APARTES_TAILLES);
    if (compte(serveur)) return serveur;
    try { return normaliser(JSON.parse(localStorage.getItem(CLE) || 'null')); } catch (e) { return vide(); }
  }
  function ecrire(o) {
    window.APARTES_TAILLES = o;
    try { localStorage.setItem(CLE, JSON.stringify(o)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('apartes:tailles', { detail: o }));
    if (!membre || APERCU) return Promise.resolve(true);
    return fetch('/apps/club21/tailles', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ tailles: o })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  var ORDRE = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  function trier(t) {
    return t.slice().sort(function (a, b) {
      var ia = ORDRE.indexOf(a), ib = ORDRE.indexOf(b);
      if (ia !== -1 || ib !== -1) return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
      return parseFloat(a) - parseFloat(b);
    });
  }
  // La liste qui s'applique à une taille donnée d'une pièce donnée.
  function groupePour(genre, valeur) {
    if (genre === 'chaussures') return 'chaussures';
    return /^\d/.test(valeur) ? 'pantalons' : 'vetements';
  }
  function resume(o) {
    var parts = [];
    if (o.vetements.length) parts.push(trier(o.vetements).join(', '));
    if (o.pantalons.length) parts.push(trier(o.pantalons).join(', '));
    if (o.chaussures.length) parts.push('pointure ' + trier(o.chaussures).join(', '));
    return parts.join(' · ');
  }
  window.ApartesTailles = { lire: lire, ecrire: ecrire };

  // Le choix des tailles (profil, barre de Vente) : chaque puce s'enregistre
  // au toucher, sans bouton « Valider ».
  function brancherChoix(bloc) {
    if (bloc.__aps) return; bloc.__aps = true;
    var etat = bloc.querySelector('[data-aps-tc-etat]');
    var minuteur;
    function peindre() {
      var o = lire();
      bloc.querySelectorAll('[data-taille]').forEach(function (b) {
        var g = b.getAttribute('data-groupe');
        b.setAttribute('aria-pressed', String(o[g].indexOf(b.getAttribute('data-taille')) !== -1));
      });
    }
    bloc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-taille]');
      if (!b) return;
      var o = lire(), g = b.getAttribute('data-groupe'), v = b.getAttribute('data-taille'), i = o[g].indexOf(v);
      if (i === -1) o[g].push(v); else o[g].splice(i, 1);
      o[g] = trier(o[g]);
      ecrire(o).then(function (ok) {
        if (!etat) return;
        etat.textContent = ok ? (APERCU ? 'Aperçu client : c’est noté pour cette visite, rien n’est enregistré.' : membre ? 'C’est noté, sur votre compte.' : 'C’est noté.') : 'Un souci de notre côté, réessayez dans un instant.';
        clearTimeout(minuteur); minuteur = setTimeout(function () { etat.textContent = ''; }, 2600);
      });
    });
    document.addEventListener('apartes:tailles', peindre);
    peindre();
  }

  // Une Vente : la barre, le filtre « seulement ma taille », la pastille.
  function brancherVente(barre) {
    var grille = document.getElementById('ProductGridContainer') || document;
    var choix = barre.querySelector('[data-aps-mt-choix]');
    var videMsg = barre.querySelector('[data-aps-mt-vide]');
    var bascule = barre.querySelector('[data-aps-mt-bascule]');
    var filtre = true;
    try { filtre = sessionStorage.getItem(CLE_FILTRE) !== 'non'; } catch (e) {}

    function appliquer() {
      var o = lire(), avec = compte(o) > 0;
      barre.setAttribute('data-etat', avec ? 'avec' : 'sans');
      var txt = resume(o), cible = barre.querySelector('[data-aps-mt-tailles]');
      if (cible.textContent !== txt) cible.textContent = txt;
      bascule.setAttribute('aria-checked', String(filtre));
      var visibles = 0, total = 0;
      grille.querySelectorAll('[data-aps-tailles]').forEach(function (li) {
        var siennes = li.getAttribute('data-aps-tailles');
        var genre = li.getAttribute('data-aps-genre') || 'haut';
        var valeurs = siennes.split('|').filter(Boolean);
        var sansTaille = siennes === '';
        var vaBien = valeurs.some(function (v) { return o[groupePour(genre, v)].indexOf(v) !== -1; });
        // Une pièce dont la liste n'est pas renseignée reste visible.
        var concernee = valeurs.some(function (v) { return o[groupePour(genre, v)].length > 0; });
        li.classList.toggle('aps-a-ma-taille', vaBien);
        var montrer = !avec || !filtre || sansTaille || !concernee || vaBien;
        li.hidden = !montrer;
        total++; if (montrer) visibles++;
      });
      videMsg.hidden = !(avec && filtre && total > 0 && visibles === 0);
    }
    barre.addEventListener('click', function (e) {
      if (e.target.closest('[data-aps-mt-ouvrir]')) { choix.hidden = !choix.hidden; return; }
      if (e.target.closest('[data-aps-mt-fermer]')) { choix.hidden = true; return; }
      if (e.target.closest('[data-aps-mt-bascule]') || e.target.closest('[data-aps-mt-tout]')) {
        filtre = e.target.closest('[data-aps-mt-tout]') ? false : !filtre;
        try { sessionStorage.setItem(CLE_FILTRE, filtre ? 'oui' : 'non'); } catch (er) {}
        appliquer();
      }
    });
    document.addEventListener('apartes:tailles', appliquer);
    // Les filtres de Dawn rechargent la grille : on repasse dessus, seulement
    // quand de nouvelles pièces arrivent (pas quand la barre change).
    if (window.MutationObserver && grille !== document) {
      new MutationObserver(function (mutations) {
        var neuves = mutations.some(function (m) {
          return !barre.contains(m.target) && Array.prototype.some.call(m.addedNodes, function (n) {
            return n.nodeType === 1 && (n.matches('[data-aps-tailles]') || (n.querySelector && n.querySelector('[data-aps-tailles]')));
          });
        });
        if (neuves) appliquer();
      }).observe(grille, { childList: true, subtree: true });
    }
    barre.hidden = false;
    appliquer();
  }

  // Une pièce : sa taille déjà choisie, et « Retenir ma taille ».
  function fieldsetTaille() {
    var trouve = null;
    document.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fs) {
      var nom = ((fs.querySelector('legend') || {}).textContent || '').toLowerCase();
      if (!trouve && /taille|size|pointure/.test(nom)) trouve = fs;
    });
    return trouve;
  }
  function brancherPiece() {
    var retenir = document.querySelector('[data-aps-retenir]');
    var genre = retenir ? retenir.getAttribute('data-genre') : 'haut';

    function marquer() {
      var fs = fieldsetTaille(); if (!fs) return null;
      var o = lire(), choisi = null;
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var v = String(inp.value).trim().toUpperCase();
        var lab = fs.querySelector('label[for="' + inp.id + '"]');
        var sienne = o[groupePour(genre, v)].indexOf(v) !== -1;
        if (lab) lab.classList.toggle('aps-ma-taille', sienne);
        if (sienne && !choisi && !inp.classList.contains('disabled') && !inp.disabled) choisi = inp;
      });
      return { fs: fs, choisi: choisi };
    }
    function majRetenir() {
      if (!retenir) return;
      var fs = fieldsetTaille(); if (!fs) return;
      var coche = fs.querySelector('input[type="radio"]:checked');
      if (!coche) { retenir.hidden = true; return; }
      var v = String(coche.value).trim().toUpperCase(), g = groupePour(genre, v);
      var dedans = lire()[g].indexOf(v) !== -1;
      retenir.hidden = false;
      retenir.setAttribute('data-valeur', v);
      retenir.querySelector('[data-aps-rt-bascule]').setAttribute('aria-checked', String(dedans));
      retenir.querySelector('[data-aps-rt-texte]').textContent = dedans
        ? 'Le ' + v + ' est retenu pour vos prochaines Ventes'
        : 'Retenir le ' + v + ' pour les prochaines Ventes';
    }
    var m = marquer();
    if (m && m.choisi && !/[?&]variant=/.test(location.search) && !m.choisi.checked) {
      var lab = m.fs.querySelector('label[for="' + m.choisi.id + '"]');
      if (lab) lab.click();
    }
    majRetenir();
    // Dawn redessine le choix des variantes après chaque clic.
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(function () { marquer(); majRetenir(); }, 60);
    });
    if (window.MutationObserver) {
      var vs = document.querySelector('variant-selects, variant-radios');
      if (vs && vs.parentNode) new MutationObserver(function () { marquer(); majRetenir(); }).observe(vs.parentNode, { childList: true });
    }
    if (retenir) retenir.addEventListener('click', function () {
      var v = retenir.getAttribute('data-valeur'); if (!v) return;
      var o = lire(), g = groupePour(genre, v), i = o[g].indexOf(v);
      if (i === -1) o[g].push(v); else o[g].splice(i, 1);
      o[g] = trier(o[g]);
      ecrire(o); marquer(); majRetenir();
    });
  }

  // ——— Ajouter à mon agenda ———
  var surApple = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
  function dejaAjoutees() { try { return JSON.parse(localStorage.getItem(CLE_AGENDA) || '[]'); } catch (e) { return []; } }
  function peindreAgenda() {
    var deja = dejaAjoutees();
    document.querySelectorAll('[data-aps-agenda-vente]').forEach(function (b) {
      var ok = deja.indexOf(b.getAttribute('data-aps-agenda-vente')) !== -1;
      b.classList.toggle('is-ajoute', ok);
      var t = b.querySelector('[data-aps-agenda-texte]');
      if (t) t.textContent = ok ? 'Dans mon agenda' : (b.getAttribute('data-libelle') || 'Ajouter à mon agenda');
    });
  }
  function gcalDate(iso) { return new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aps-agenda-vente]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var handle = b.getAttribute('data-aps-agenda-vente');
    if (surApple) {
      location.href = '/apps/club21/agenda/vente/' + handle + '.ics?avance=' + (b.getAttribute('data-avance') || 0);
    } else {
      var debut = b.getAttribute('data-debut'), titre = b.getAttribute('data-titre') || '';
      var fin = new Date(new Date(debut).getTime() + 3600e3).toISOString();
      var url = 'https://apartes.fr/collections/' + handle;
      window.open('https://calendar.google.com/calendar/render?action=TEMPLATE' +
        '&text=' + encodeURIComponent('Vente ' + titre + ' · Apartés') +
        '&dates=' + gcalDate(debut) + '/' + gcalDate(fin) +
        '&details=' + encodeURIComponent('La Vente ' + titre + ' s’ouvre pour vous, avant tout le monde.\n' + url), '_blank', 'noopener');
    }
    var deja = dejaAjoutees();
    if (deja.indexOf(handle) === -1) { deja.push(handle); try { localStorage.setItem(CLE_AGENDA, JSON.stringify(deja)); } catch (er) {} }
    peindreAgenda();
  }, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('span[data-aps-agenda-vente]')) { e.preventDefault(); e.target.click(); }
  });

  // ——— L'accueil : bonjour ou bonsoir, à l'heure de la personne ———
  function saluer(el) {
    var h = new Date().getHours();
    var mot = (h >= 18 || h < 5) ? 'Bonsoir' : 'Bonjour';
    var prenom = el.getAttribute('data-prenom');
    el.textContent = mot + (prenom ? ' ' + prenom : '');
    el.hidden = false;
  }

  function demarrer() {
    document.querySelectorAll('[data-aps-tailles-choix]').forEach(brancherChoix);
    document.querySelectorAll('[data-aps-ma-taille]').forEach(brancherVente);
    document.querySelectorAll('[data-aps-salut]').forEach(saluer);
    if (document.querySelector('variant-selects, variant-radios')) brancherPiece();
    peindreAgenda();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();

// La demande qu'on n'a pas pu servir : quand quelqu'un choisit une taille déjà
// partie, la marque le saura (espace marque, « Aujourd'hui »). Une fois par
// personne, par taille et par jour ; rien d'autre n'est envoyé.
(function () {
  function brancher() {
    if (window.APARTES_APERCU) return; // l'équipe en aperçu ne compte pas dans les chiffres des marques
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant;
      if (!v || v.available || !v.id) return;
      var info = document.querySelector('product-info[data-product-id]');
      var p = info && info.getAttribute('data-product-id');
      if (!p) return;
      var cle = p + ':' + v.id, jour = new Date().toISOString().slice(0, 10), vus = {};
      try { vus = JSON.parse(localStorage.getItem('apartes-envies') || '{}') || {}; } catch (err) { vus = {}; }
      if (vus[cle] === jour) return;
      vus[cle] = jour;
      try { localStorage.setItem('apartes-envies', JSON.stringify(vus)); } catch (err) { /* sans mémoire */ }
      var url = '/apps/club21/envie?p=' + encodeURIComponent(p) + '&v=' + encodeURIComponent(v.id);
      if (navigator.sendBeacon) navigator.sendBeacon(url);
      else fetch(url, { method: 'POST', keepalive: true }).catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
})();

// Le parcours d'une pièce, pour la marque : une vue de la fiche et un ajout
// au panier, une fois par personne et par jour. L'ajout dit aussi sa taille
// (la variante), comptée elle aussi une fois par jour. Rien d'autre n'est envoyé.
(function () {
  function signal(type, p, v) {
    var cle = type + ':' + p, cleTaille = v ? cle + ':' + v : '', jour = new Date().toISOString().slice(0, 10), vus = {};
    try { vus = JSON.parse(localStorage.getItem('apartes-parcours') || '{}') || {}; } catch (err) { vus = {}; }
    var piece = vus[cle] !== jour, taille = !!cleTaille && vus[cleTaille] !== jour;
    if (!piece && !taille) return;
    vus[cle] = jour;
    if (cleTaille) vus[cleTaille] = jour;
    try { localStorage.setItem('apartes-parcours', JSON.stringify(vus)); } catch (err) { /* sans mémoire */ }
    var url = '/apps/club21/envie?t=' + type + '&p=' + encodeURIComponent(p) + (taille ? '&v=' + encodeURIComponent(v) : '') + (piece ? '' : '&seul=taille');
    if (navigator.sendBeacon) navigator.sendBeacon(url); else fetch(url, { method: 'POST', keepalive: true }).catch(function () {});
  }
  function brancher() {
    if (window.APARTES_APERCU) return; // l'équipe en aperçu ne compte pas dans les chiffres des marques
    var info = document.querySelector('product-info[data-product-id]');
    var p = info && info.getAttribute('data-product-id');
    if (!p) return;
    signal('vue', p);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (e && e.source === 'product-form') signal('panier', p, /^\d+$/.test(String(e.productVariantId || '')) ? String(e.productVariantId) : ''); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher); else brancher();
})();
